import passwordComponent  from './password.component';
import PasswordService    from './password.service';

const PasswordModule = angular
  .module('password', [])
  .service('$password', PasswordService)
  .component('password', passwordComponent);

export default PasswordModule;


/** WEBPACK FOOTER **
 ** ./frontend/components/auth/password/password.js
 **/